import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const CustomTabPanel = ({ children, value, index, description, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: {
              xs: "14px",   // mobile
              sm: "16px",   // tablet
              md: "18px",   // small laptop
              lg: "20px",   // desktop
            },
            fontWeight: "bold",
            border: "thin solid black",
            borderRadius: "5px",
            marginLeft: "10%",
            marginRight: "10%",
            marginTop: "5px",
            marginBottom: "20px",
          }}
        >
          {description}
        </Typography>
        {children}
      </Box>
      )}
    </div>
  );
};

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  description: PropTypes.string,
};

export default CustomTabPanel;
